import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import SelectField from '../../Pages/CryptoTransfer/SelectField';

import 'react-datepicker/dist/react-datepicker.css';
import { transformData } from '../../../services/helpers';

const GlobalSearch = ({ onSubmit, placeholder, field, data }) => {
  const [value, setValue] = useState('');
  const [select, setSelect] = useState(field);

  const [startDateFrom, setStartDateFrom] = useState(new Date());
  const [startDateTo, setStartDateTo] = useState(new Date());

  useEffect(() => {
    setValue('');
  }, [select]);

  const handleChange = e => {
    setValue(e.target.value);
  };

  const handleSubmit = e => {
    e.preventDefault();

    if (select === 'date') {
      onSubmit({
        startDateFrom: transformData(startDateFrom.getTime() / 1000, 'YYYY-MM-DD'),
        startDateTo: transformData(startDateTo.getTime() / 1000, 'YYYY-MM-DD'),
        select,
      });
    } else {
      onSubmit({ value, select });
    }
  };

  const handleReset = e => {
    e.preventDefault();
    setValue('');
    onSubmit({ value: '', select });
  };

  return (
    <>
      <form
        className="dash-search"
        onSubmit={handleSubmit}
        style={{ marginRight: select === 'date' ? '25px' : 0 }}
      >
        {field ? (
          <SelectField data={data} value={select} onChange={setSelect} />
        ) : null}

        {select === 'date' ? (
          <>
            <DatePicker
              className="form-item"
              selected={startDateFrom}
              onChange={date => {
                setStartDateFrom(date);
              }}
            />
            <DatePicker
              className="form-item"
              selected={startDateTo}
              onChange={date => {
                setStartDateTo(date);
              }}
              style={{ marginRight: '25px' }}
            />
            <button
              type="submit"
              style={{
                right: 95,
                width: 25,
                padding: '0 5px',
              }}
              className="field-icon field-icon--right"
            >
              <svg
                style={{ pointerEvents: 'none' }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.2 23.2L16.8 16.8M10.4 20C5.09812 20 0.800049 15.7019 0.800049 10.4C0.800049 5.09805 5.09812 0.799988 10.4 0.799988C15.702 0.799988 20 5.09805 20 10.4C20 15.7019 15.702 20 10.4 20Z"
                  stroke="#9B9B9B"
                />
              </svg>
            </button>
          </>
        ) : (
          <div className="field-wrap">
            <input
              value={value}
              onChange={handleChange}
              type="text"
              style={{ paddingRight: 60 }}
              className="form-item"
              placeholder={placeholder}
            />
            <button
              type="submit"
              style={{ right: 30, width: 25, padding: '0 5px' }}
              className="field-icon field-icon--right"
            >
              <svg
                style={{ pointerEvents: 'none' }}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M23.2 23.2L16.8 16.8M10.4 20C5.09812 20 0.800049 15.7019 0.800049 10.4C0.800049 5.09805 5.09812 0.799988 10.4 0.799988C15.702 0.799988 20 5.09805 20 10.4C20 15.7019 15.702 20 10.4 20Z"
                  stroke="#9B9B9B"
                />
              </svg>
            </button>
            <button
              type="button"
              style={{ right: 5, width: 25, padding: '0 6px' }}
              onClick={handleReset}
              className="field-icon field-icon--right"
            >
              <svg
                style={{ pointerEvents: 'none' }}
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0.5 0.5L12.5 12.5M0.5 12.5L12.5 0.5" stroke="#9B9B9B" />
              </svg>
            </button>
          </div>
        )}
      </form>
    </>
  );
};

export default GlobalSearch;
